<template>
  <pt-lab-test-platform-update class="pt-lab-test-platform-update__withData"></pt-lab-test-platform-update>
</template>

<script>
import PtLabTestPlatformUpdate from './index'
export default {
  name: 'pt-lab-test-platform-update__withData',
  components: {
    'pt-lab-test-platform-update': PtLabTestPlatformUpdate
  }
}
</script>
